import React from 'react';
import './MainLayout.scss';
import { Route } from 'react-router-dom';
import MenuTopContainer from 'Components/MenuTop/MenuTopContainer';
import MenuMainContainer from 'Components/MenuMain/MenuMainContainer';
import MenuFooterContainer from 'Components/MenuFooter/MenuFooterContainer';
import TitleComponent from 'Helpers/DynamicTitle';

interface IProps {
  component?: any;
  path?: string;
  exact?: boolean;
  title?: string;
}

const MainLayout: React.SFC<IProps> = ({ component: Component, children, title, ...rest }) => (
  <Route { ...rest } render={ matchProps => (
    <>
      <TitleComponent title={ title } />
      <div className='main-layout'>
        <MenuTopContainer />
        <MenuMainContainer />
        { Component && <Component { ...matchProps } /> }
        { children }
        <MenuFooterContainer />
      </div>
    </>
  ) } />
);

export default MainLayout;


// WEBPACK FOOTER //
// ./src/layouts/MainLayout/MainLayout.tsx